import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const getProviderSpecificConfiguration = ({ providerCode, appConfiguration }) => {
  if (!providerCode) {
    return {};
  }
  // we ignore appConfiguration.status as providerSpecific is immutable in short period of time
  return providerCode === appConfiguration?.providerSpecific?.code ? appConfiguration?.providerSpecific : {};
};

export const useProviderSpecificConfiguration = () => {
  const {
    appConfiguration,
    providerCode,
  } = useSelector((state) => ({
    appConfiguration: state.appConfiguration,
    providerCode: state.provider,
  }), shallowEqual);

  return useMemo(
    () => getProviderSpecificConfiguration({ providerCode, appConfiguration }),
    [providerCode, appConfiguration],
  );
};
